

























import { Vue, Component, Prop } from "vue-property-decorator";
import NominaResponsabileReview from "../../components/ReviewDoc/NominaResponsabileReview.vue";
import AutorizzazioneStudenti from "../../components/ReviewDoc/AutorizzazioneStudenti.vue";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { UserInfo } from "../../_models/userInfo";
import { router } from "../../_router";
import { DocNominaResponsabileInfo } from "../../_models/docNominaResponsabileInfo";
import { DocAutorizzazioneInfo } from "../../_models/docAutorizzazioneInfo";

@Component({
  components: {
    NominaResponsabileReview,
    AutorizzazioneStudenti
  }
})
export default class Review extends Vue {
  @Prop() docType!: string;
  @Prop() idDoc!: number;
  @Prop() idStatoDoc!: number;
  @Prop() ruoloUtente!: number;
  // private docNominaResponsabile: DocNominaResponsabileInfo;
  // private docAutorizzazioneStudente: DocAutorizzazioneInfo;

  // constructor() {
  //   super();
  //   // this.docNominaResponsabile = {
  //   //   nomeAzienda: "",
  //   //   nomeIstituto: "",
  //   //   idAzienda: 0,
  //   //   idIstituto: 0,
  //   //   dataDocumento: "",
  //   //   firmaUno: "",
  //   //   firmaDue: "",
  //   //   idDoc: 0
  //   // };
  //   // this.docAutorizzazioneStudente = {

  //   // }
  // }

  created() {
    if (this.ruoloUtente !== null && this.ruoloUtente !== undefined) {
      // const payload = {
      //   idDoc: this.idDoc
      // };
      // if (this.docType === "autorizzazioneStudente") {
      //   data
      //     .dispatchDocAutorizzazioneInfo(this["$store"], payload)
      //     .catch(error => {
      //       if (error.response.status === 401) {
      //         bus.$emit("errorOperation", error.response.statusText);
      //         this["$router"].push("/login");
      //       } else {
      //         bus.$emit("errorOperation", error.response.statusText);
      //       }
      //     });
      // } else {
      //   data
      //     .dispatchDocNominaRespInfo(this["$store"], payload)
      //     .then(result => {
      //       this.docNominaResponsabile = result;
      //     })
      //     .catch(error => {
      //       if (error.response.status === 401) {
      //         bus.$emit("errorOperation", error.response.statusText);
      //         this["$router"].push("/login");
      //       } else {
      //         bus.$emit("errorOperation", error.response.statusText);
      //       }
      //     });
      // }
    } else {
      router.push({
        name: "profilo",
        params: {}
      });
    }
  }
}
